import * as locales from '~/translations/wti'

export const DEFAULT_LOCALE = 'en'
export const SUPPORTED_LOCALES = Object.keys(locales)

if (!SUPPORTED_LOCALES.includes(DEFAULT_LOCALE)) {
  throw new Error(`Unsupported locale: ${DEFAULT_LOCALE}`)
}
